'use client';

import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { useEffect } from 'react';

const apiKey = process.env.NEXT_PUBLIC_AMPLITUDE_ANALYTICS;

export type EventProperties = {
  userId?: string;
  deviceId?: string;
  sessionId?: string;
  eventType?: string;
  eventProperties?: string;
  userProperties?: string;
  appVersion?: string;
  osName?: string;
  osVersion?: string;
  deviceBrand?: string;
  deviceManufacturer?: string;
  deviceModel?: string;
  locationLat?: string;
  locationLng?: string;
  [key: string]: any;
};

export const initializeAmplitude = () => {
  if (!apiKey) {
    return null;
  }

  // Create and Install Session Replay Plugin
  const sessionReplayTracking = sessionReplayPlugin({
    sampleRate: 1,
  });

  amplitude.init(apiKey, {
    defaultTracking: {
      sessions: true,
      pageViews: true,
      formInteractions: true,
    },
  });

  amplitude.add(sessionReplayTracking);

  return amplitude;
};

/**
 * Set the user in Amplitude
 */
export const assignUser = (email?: string | null) => {
  if (!email) {
    return;
  }

  amplitude.setUserId(email);
};

/**
 * Reset the user in Amplitude
 */
export const resetUser = () => {
  amplitude.reset();
};

/**
 * Track an event in Amplitude
 */
export const trackEvent = (eventName: string, eventProperties: EventProperties = {}) => {
  amplitude.track(eventName, eventProperties);
};

/**
 * Wrap amplitude into the client side only component
 */
export const AmplitudeScript = () => {
  useEffect(() => {
    initializeAmplitude();
  }, []);

  return null;
};
